import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { AnalyticsFilterState } from "@/types/analytics.types";
import { AnalyticsData } from "@/types/common.types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";

export default function useGetAnalyticsDataQuery(
  jobId: string,
  filters: AnalyticsFilterState = {},
  options?: Omit<
    UseQueryOptions<
      Record<string, AnalyticsData[]>,
      HTTPError,
      AnalyticsData[], // Update return type here
      ["analyticsData", string, AnalyticsFilterState]
    >,
    "queryKey" | "queryFn"
  >
) {
  return useQuery({
    queryKey: ["analyticsData", jobId, filters],
    queryFn: async () => {
      const searchParams = new URLSearchParams();

      // Add all selected filters to the query params
      Object.entries(filters).forEach(([category, values]) => {
        values.forEach((value) => {
          searchParams.append(category, value);
        });
      });

      const url = `${ENDPOINTS.GET_ANALYTICS_TABLE_DATA_BY_JOB_ID(jobId)}${
        searchParams.toString() ? `?${searchParams.toString()}` : ""
      }`;

      const response = await apiClient
        .get(url)
        .json<Record<string, AnalyticsData[]>>();
      return response;
    },
    select: (data) => Object.values(data).map((dataArray) => dataArray[0]),
    ...options,
  });
}
